import { message } from 'antd'
import instituteSelector from 'modules/Auth/selectors'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import adminRequest from 'utils/adminRequest'
import corporateRequest from 'utils/corporateRequest'
import instRequest from 'utils/instRequest'
import request from 'utils/request'
import studentRequest from 'utils/studentRequest'

export const SET_STUDENTS_LIST = 'institute/SET_STUDENTS_LIST'
export const SET_SINGLE_STUDENTS_DATA = 'institute/SET_SINGLE_STUDENTS_DATA'
export const SET_STUDENTS_METRICS_DATA = 'institute/SET_STUDENTS_METRICS_DATA'
export const SET_STUDENTS_LIST_COUNT = 'institute/SET_STUDENTS_LIST_COUNT'
export const SET_STUDENTS_DEGREE_LIST = 'institute/SET_STUDENTS_DEGREE_LIST'
export const SET_STUDENT_PENDING_DATA = 'institute/SET_STUDENT_PENDING_DATA'

export const setStudentsList = data => {
  return {
    type: SET_STUDENTS_LIST,
    data,
  }
}

export const setSingleStudentData = data => {
  return {
    type: SET_SINGLE_STUDENTS_DATA,
    data,
  }
}

export const setStudentMetricsData = data => {
  return {
    type: SET_STUDENTS_METRICS_DATA,
    data,
  }
}
export const setStudentDegreeData = data => {
  return {
    type: SET_STUDENTS_DEGREE_LIST,
    data,
  }
}

export const setStudentPendingData = data => {
  return {
    type: SET_STUDENT_PENDING_DATA,
    data,
  }
}

export const setNotificationCatalogues = data => {
  return {
    type: 'SET_NOTIFICATION_CATALOGUES',
    data,
  }
}

export const getStudentsListData =
  (setLoading, query = 'pageLimit=10&pageNo=0', fromDelete = false) =>
  async (dispatch, getState) => {
    const state = getState()
    const institute_id = instituteSelector.getInstituteDetails(state).id
    if (setLoading && !fromDelete) {
      setLoading(true)
    }

    try {
      const data = await studentRequest.get(
        `/students/${institute_id}/lists?${query}`,
        {}
      )
      dispatch(setStudentsList(data?.data || {}))
      dispatch(studentsMetricsData())
      if (setLoading && !fromDelete) {
        setLoading(false)
      }
    } catch (error) {
      if (setLoading && !fromDelete) {
        setLoading(false)
      }
    }
  }

  export const getStudentsListResume =
  (setLoading, query = 'pageLimit=10&pageNo=0', fromDelete = false) =>
  async (dispatch, getState) => {
    const state = getState()
    const institute_id = instituteSelector.getInstituteDetails(state).id
    if (setLoading && !fromDelete) {
      setLoading(true)
    }

    try {
      const data = await studentRequest.get(
        `/students/${institute_id}/lists?${query}`,
        {}
      )
      if (setLoading && !fromDelete) {
        setLoading(false)
      }
      return data.data;
    } catch (error) {
      if (setLoading && !fromDelete) {
        setLoading(false)
      }
    }
  }

export const createStudent =
  (data, courseId, eventId, setPrevDrawer, onClearAll) =>
  async (dispatch, getState) => {
    const state = getState()
    const institute_id = instituteSelector.getInstituteDetails(state).id
    let event = eventId ? `?eventId=${eventId}` : ``
    try {
      await studentRequest.post(
        `/students/${institute_id}/${courseId}${event}`,
        data
      )
      dispatch(getStudentsListData())
      onClearAll()
      SuccessMessage('Student Added successfully.')
      setPrevDrawer(false)
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
    }
  }

export const getSingleStudentData =
  student_id => async (dispatch, getState) => {
    try {
      const res = await studentRequest.get(`/students/${student_id}`)
      dispatch(setSingleStudentData(res?.data?.data || {}))
      return true
    } catch (error) {}
  }

export const deleteStudent = student_id => async (dispatch, getState) => {
  try {
    let response = await studentRequest.delete(`/students/${student_id}`)
    SuccessMessage('Student deleted successfully.')
    return response
  } catch (error) {
    ErrorMessage(
      error?.response?.data?.message || 'Failed to delete the student.'
    )
    return error
  }
}

export const deleteBulkStudents = (payLoad, query) => async dispatch => {
  try {
    await studentRequest({
      method: 'delete',
      url: `students/deletebulk`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(payLoad),
    })
    let urlQuery
    if (query) {
      urlQuery = query + '&pageLimit=10&pageNo=0'
    }
    dispatch(getStudentsListData(false, urlQuery, true))
    SuccessMessage('Student deleted successfully.')
  } catch (error) {
    message.error(`Failed to delete selected students!`)
  }
}

export const editStudent =
  (student_id, data, setPrevDrawer, onClearAll, query) =>
  async (dispatch, getState) => {
    try {
      await studentRequest.put(`/students/${student_id}`, data)
      let urlQuery
      if (query) {
        urlQuery = query
      }
      dispatch(getStudentsListData(false, urlQuery))
      onClearAll()
      SuccessMessage('Student Edited successfully.')
      setPrevDrawer(false)
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
    }
  }

export const studentsMetricsData = () => async (dispatch, getState) => {
  const state = getState()
  const institute_id = instituteSelector.getInstituteDetails(state).id

  try {
    const res = await studentRequest.get(`/students/${institute_id}/metrics`)
    dispatch(setStudentMetricsData(res?.data?.data || {}))
  } catch (error) {}
}

export const blacklistStudent =
  (student_id, data, clearAll, setBlacklistDrawer) =>
  async (dispatch, getState) => {
    try {
      await studentRequest.post(`/students/${student_id}/blacklist`, data)
      // dispatch(getStudentsListData())
      clearAll()
      setBlacklistDrawer(false)
      SuccessMessage('Success')
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const activeInactivateStatus =
  (student_id, data) => async (dispatch, getState) => {
    try {
      await studentRequest.post(`/students/${student_id}/status`, data)
    } catch (error) {}
  }
export const reInviteStudent =
  (student_id, data) => async (dispatch, getState) => {
    let payload = {
      eventId: data,
    }
    try {
      let res = await request.post(
        `/user/student/${student_id}/studentreinvitation`,
        payload
      )
      if (res.status === 200) {
        SuccessMessage(res.data.message)
      }
    } catch (error) {}
  }
export const bulkReInviteStudent = payload => async (dispatch, getState) => {
  const state = getState()
  try {
    let res = await request.post(
      `/user/student/${state?.auth?.instituteDetails?.id}/bulk/studentreinvitation`,
      payload
    )
    return res
  } catch (error) {}
}
export const getDegreeData =
  (query = 'pageLimit=100&pageNo=0') =>
  async (dispatch, getState) => {
    const state = getState()
    try {
      const res = await instRequest.get(
        `/institutes/instituteCampus/${state?.auth?.instituteDetails?.id}/courses?${query}`
      )
      let courses = res?.data?.data?.courses
      if (courses.length) {
        courses = courses.map(val => {
          return {
            ...val?.degreeStreamMap?.degree,
            degreeId: val.id,
            domainId: val?.degreeStreamMap?.degree?.domain?.id,
            domain: val?.degreeStreamMap?.degree?.domain?.name,
            stream: {
              ...val?.degreeStreamMap?.stream,
              specialisation: val?.courseSpecialisationMap,
              degreeStreamMapId: val?.degreeStreamMapId,
            },
            duration: val?.degreeStreamMap?.duration,
            examType: val?.degreeStreamMap?.examType,
            specialisation: val?.courseSpecialisationMap,
            degreeStreamMapId: val?.degreeStreamMapId,
          }
        })
        const newArray = []
        for (let i = 0; i < courses.length; i++) {
          const index = newArray.findIndex(val => val.id === courses[i].id)
          if (index > -1) {
            newArray[index].stream.push(courses[i].stream)
          } else {
            newArray.push({
              id: courses[i].id,
              degreeId: courses[i].degreeId,
              domainId: courses[i].domainId,
              domain: courses[i].domain,
              name: courses[i].name,
              status: courses[i].status,
              shortForm: courses[i].shortForm,
              type: courses[i].type,
              stream: [courses[i].stream],
              examType: courses[i].examType,
              duration: courses[i].duration,
              specialisation: courses[i].specialisation,
              degreeStreamMapId: courses[i].degreeStreamMapId,
            })
          }
        }

        dispatch(setStudentDegreeData(newArray))
        return true
      }
    } catch (error) {}
  }
export const bulkUploadStudents = payload => async (dispatch, getState) => {
  try {
    await studentRequest.post(`/students/bulkcreate`, payload)
    dispatch(getStudentsListData())
    return true
  } catch (error) {}
}

export const getNotificationCatalogues =
  eventId => async (dispatch, getState) => {
    try {
      const result = await adminRequest.get(
        `notificationCatalogue?pageLimit=10&pageNo=0${eventId}`
      )
      dispatch(setNotificationCatalogues(result?.data?.data))
      return result?.data?.data
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
      dispatch(setNotificationCatalogues([]))
      return error
    }
  }

export const sendNotificationEmail = payload => async (dispatch, getState) => {
  try {
    let res = await request.post(`/notification/email`, payload)
    if (res.status === 200) {
      SuccessMessage(res.data.message)
    }
  } catch (error) {}
}

// --- Notification de-duplication -------------------------------------------
// Several ATS code paths (bulk upload, manual status change, conflict
// resolution) independently build and dispatch the same notification when a
// single candidate is touched by more than one flow. That produced duplicate
// "You've been Selected" emails / WhatsApp / in-app messages. Drop any
// notification whose key was already sent within the window below. The two
// paths read the recipient from different sources, so keys are normalised
// (email lower-cased, phone reduced to its last 10 digits to collapse
// country-code variants) and built from path-stable fields only — never the
// student name, which is formatted differently per path. The cache is
// in-memory (per session) and self-purges.
const NOTIFICATION_DEDUP_WINDOW_MS = 60 * 1000
const recentNotifications = new Map()

// Recipients per /notification/bulkEmail request. Matches the batch size the
// corporate service already uses for its own bulk invite sends.
const BULK_EMAIL_BATCH_SIZE = 50

const normalizeEmailKey = v => String(v ?? '').trim().toLowerCase()
const normalizePhoneKey = v => {
  const digits = String(v ?? '').replace(/\D/g, '')
  return digits.length > 10 ? digits.slice(-10) : digits
}

const isDuplicateNotification = key => {
  if (!key) return false
  const now = Date.now()
  for (const [k, ts] of recentNotifications) {
    if (now - ts > NOTIFICATION_DEDUP_WINDOW_MS) recentNotifications.delete(k)
  }
  if (recentNotifications.has(key)) return true
  recentNotifications.set(key, now)
  return false
}

export const sendNotificationBulkEmail =
  (payload,noMessage = false) => async (dispatch, getState) => {
    try {
      const emails = Array.isArray(payload)
        ? payload.filter(
            e =>
              !isDuplicateNotification(
                `email|${normalizeEmailKey(e?.to)}|${e?.subject}`
              )
          )
        : payload
      if (Array.isArray(emails) && emails.length === 0) return
      if (!Array.isArray(emails)) {
        await request.post(`/notification/bulkEmail`, emails)
        return
      }
      // The API caps the request body at 1MB. A role floated to a few hundred
      // students carries one full email body per recipient, so the whole batch
      // is sent in fixed-size chunks instead of a single oversized request.
      const batches = []
      for (let i = 0; i < emails.length; i += BULK_EMAIL_BATCH_SIZE) {
        batches.push(emails.slice(i, i + BULK_EMAIL_BATCH_SIZE))
      }
      await Promise.all(
        batches.map(batch => request.post(`/notification/bulkEmail`, batch))
      )
      // if (res.status === 200 && noMessage) {
      //   SuccessMessage(res.data.message)
      // }
    } catch (error) {}
  }

export const SelectUnRestricted = payload => async (dispatch, getState) => {
  try {
    await corporateRequest.post(`/corporates/student/unRestrict`, payload)

    SuccessMessage('Student UnRestricted successfully.')
  } catch (error) {
    ErrorMessage(error?.response?.data?.message)
  }
}

export const getConsentDrawerList = (studentId, updatedPayload) => async () => {
  try {
    const response = await corporateRequest.post(
      `/corporate/student/${studentId}/requestDrawer`,
      updatedPayload
    )

    return response
  } catch (error) {
    console.error('Error fetching TPO user list:', error)
    ErrorMessage('Error fetching roles, Try again.')

    return false
  }
}
export const SelectBlacklist = payload => async (dispatch, getState) => {
  try {
    await studentRequest.put(`/student/corporates/blacklist`, payload)

    SuccessMessage('Student Blacklist successfully.')
  } catch (error) {
    ErrorMessage(error?.response?.data?.message)
  }
}

export const sendInAppNotification =
payload => async (dispatch, getState) => {
  try {
    let body = payload
    const students = payload?.notification?.students
    if (Array.isArray(students)) {
      const filtered = students.filter(s => {
        // Use the action route (carries the roleId) rather than `body`, which
        // embeds the differently-formatted student name in each path.
        const route = Array.isArray(s?.actions)
          ? s.actions[0]?.route || s.actions[0]?.deep_link || ''
          : ''
        return !isDuplicateNotification(
          `inapp|${(s?.ids || []).join(',')}|${s?.tag}|${route}`
        )
      })
      if (filtered.length === 0) return
      body = {
        ...payload,
        notification: { ...payload.notification, students: filtered },
      }
    }
    await request.post(`/users/createNotification`, body)
  } catch (error) {
    //console.log('Error in activate/inactive a student', error)
  }
}

export const sendNotificationBulkEmailWhatsapp = payload => async () => {
  try {
    const messages = Array.isArray(payload)
      ? payload.filter(
          m =>
            !isDuplicateNotification(
              `whatsapp|${normalizePhoneKey(m?.to)}|${m?.templateName}`
            )
        )
      : payload
    if (Array.isArray(messages) && messages.length === 0) return
    await request.post(`/notification/bulkWhatsapp`, messages)
  } catch (error) {
    return error
  }
}
export const getStudentPendingData = studentId => async (dispatch, getState) => {
  try {
    const response = await studentRequest.get(`/students/${studentId}/pending-data`)
    dispatch(setStudentPendingData(response.data))
    return response.data
  } catch (error) {
    ErrorMessage(error?.response?.data?.message)
    throw error
  }
}

export const SelectOptOutlist = payload => async (dispatch, getState) => {
  try {
    await studentRequest.put(`/students/approveOptedStatus`, payload)

    SuccessMessage('Student Approved successfully.')
  } catch (error) {
    ErrorMessage(error?.response?.data?.message)
  }
}
